import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG } from '@boma/app-config';
import {
  ICountry,
  ITaxDefinition,
} from '@boma/administration-portal/shared/entities';

@Injectable({
  providedIn: 'root',
})
export class CountriesService {
  private base: string;
  private version: string;
  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  loadCountries() {
    return this.httpClient.get<ICountry[]>(
      `${this.base}api/v${this.version}/Countries`
    );
  }

  createCountry(country: ICountry) {
    return this.httpClient.post<ICountry>(
      `${this.base}api/v${this.version}/Countries`,
      {
        ...country,
      }
    );
  }

  loadCountryDetails(countryId: string) {
    return this.httpClient.get<ICountry>(
      `${this.base}api/v${this.version}/Countries/${countryId}`
    );
  }

  updateCountry(countryId: string, country: ICountry) {
    return this.httpClient.put<ICountry>(
      `${this.base}api/v${this.version}/Countries/${countryId}`,
      {
        ...country,
      }
    );
  }

  addTaxDefinition(countryId: string, definition: ITaxDefinition) {
    return this.httpClient.post<ICountry>(
      `${this.base}api/v${this.version}/Countries/${countryId}/TaxDefinitions`,
      {
        ...definition,
      }
    );
  }
}
